import React from "react";
import PropTypes from "prop-types";
import { CreateContainer } from "./ContainerCreate";
import { getRelatedPosts } from "../api/getDetailPost";

class RelatedPostsContainer extends React.Component {
  componentDidMount() {
    const { id } = this.props;
    //const decoded = decodeURIComponent(artist);
    //console.log("decoded:", decoded);
    this.props.request(id);
  }

  render = () => {
    const { data, loading, failure, render } = this.props;
    const posts = (data && data.data.posts) || {};
    let error = false;
    if (Object.keys(posts).length === 0) {
      error = true;
      console.log("error:", error);
    }
    return !loading && render({ posts, loading, failure: error || failure });
  };
}

RelatedPostsContainer.propTypes = {
  id: PropTypes.number.isRequired,
};

export default CreateContainer(getRelatedPosts, RelatedPostsContainer);
